<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { headlineText, headlineType, mainText, link, rightImage } =
  props.content.data;
</script>
<template>
  <section class="prose-p:text-sm relative">
    <div class="container">
      <div class="flex flex-wrap gap-y-10 items-center mb-10">
        <div class="w-full md:w-3/5 md:pr-4 laptop:px-28 mobile:text-center">
          <SharedHeadline
            :headline="headlineText"
            :headlineType="headlineType"
            class="font-bold text-3xl lg:text-[3.125rem]/[4.1rem] mb-7"
          ></SharedHeadline>
          <div v-html="mainText"></div>
          <NuxtImg
            loading="eager"
            src="/images/layer2.svg"
            alt="layer1"
            width="299"
            height="282"
            class="max-w-[20%] hidden lg:block absolute xl:left-48 top-8 pointer-events-none z-0 rotate-180"
          />
        </div>
        <div class="w-full md:w-2/5 ml-auto text-center">
          <NuxtImg
            v-if="rightImage && rightImage.media"
            :src="rightImage.media.url"
            alt=""
            width="452"
            height="512"
            class="z-10 mx-auto"
          />
          <NuxtImg
            loading="eager"
            src="/images/layer4.svg"
            alt="layer1"
            width="299"
            height="282"
            class="max-w-[20%] hidden lg:block absolute right-0 xl:right-48 -bottom-8 pointer-events-none z-0"
          />
        </div>
      </div>
    </div>
  </section>
</template>
